import React from "react";

const Header = ({ onRegister }) => {
  return (
    <header
      className="luxe-header fixed top-0 left-0 right-0 z-50"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <a
          href="#top"
          className="flex flex-col leading-none"
          data-testid="brand-logo"
        >
          <span className="eyebrow" style={{ fontSize: "0.62rem" }}>
            The Journey
          </span>
          <span
            className="font-serif italic"
            style={{
              fontSize: "1.5rem",
              color: "var(--ink)",
              letterSpacing: "0.02em",
              lineHeight: "1.1",
            }}
          >
            to Freedom
          </span>
        </a>

        <div className="hidden md:flex items-center gap-10">
          <a
            href="#discover"
            className="text-sm tracking-wider text-[color:var(--ink-soft)] hover:text-[color:var(--gold-deep)] transition-colors"
            data-testid="nav-discover"
          >
            The Masterclass
          </a>
          <a
            href="#host"
            className="text-sm tracking-wider text-[color:var(--ink-soft)] hover:text-[color:var(--gold-deep)] transition-colors"
            data-testid="nav-host"
          >
            Your Host
          </a>
        </div>

        <button
          onClick={onRegister}
          className="btn-outline text-xs px-5 py-3"
          data-testid="header-register-btn"
        >
          Register
        </button>
      </div>
    </header>
  );
};

export default Header;
